import request from '@/utils/request'

export function login(data) {
	return request({
		url: '/open/login',
		method: 'post',
		data
	})
}

export function updateProduct(data) {
	return request({
		url: '/product/' + data.id,
		method: 'put',
		data
	})
}
